module.exports = __webpack_public_path__ + "img/hr-garballo-mini-dry-09.a74368dc.png";